// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flex {
  display: flex;
}

.supportNote {
  margin: 2px 0 6px 0; /*Prashant Gaikwad changes*/
  font-size: 0.8rem;
  font-style: italic;
  color: #99a4ba;
}

.grid-layout {
  display: grid;
  grid-column-gap: 12px;
  grid-template-columns: auto auto;
  max-width: 350px;
  margin-left: 11rem;
}

.highlightBox sym-button {
  margin-left: 1rem;
}

.highlightBox h3 {
  white-space: nowrap;
}

@media only screen and (max-width: 567px) {
  .highlightBox sym-button {
    margin-left: 0rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/agent/agent-party-details/agent-party-details.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AACA;EACE,mBAAA,EAAA,2BAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAEF;;AAAA;EACE,aAAA;EACA,qBAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;AAGF;;AAAA;EACE,iBAAA;AAGF;;AAAA;EACE,mBAAA;AAGF;;AAAA;EACE;IACE,iBAAA;EAGF;AACF","sourcesContent":[".flex {\r\n  display: flex;\r\n}\r\n.supportNote {\r\n  margin: 2px 0 6px 0; /*Prashant Gaikwad changes*/\r\n  font-size: 0.8rem;\r\n  font-style: italic;\r\n  color: #99a4ba;\r\n}\r\n.grid-layout {\r\n  display: grid;\r\n  grid-column-gap: 12px;\r\n  grid-template-columns: auto auto;\r\n  max-width: 350px;\r\n  margin-left: 11rem;\r\n}\r\n\r\n.highlightBox sym-button {\r\n  margin-left: 1rem;\r\n}\r\n\r\n.highlightBox h3 {\r\n  white-space: nowrap;\r\n}\r\n\r\n@media only screen and (max-width: 567px) {\r\n  .highlightBox sym-button {\r\n    margin-left: 0rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
